import { render } from "./GzList.vue?vue&type=template&id=2adc05d0&scoped=true"
import script from "./GzList.vue?vue&type=script&lang=js"
export * from "./GzList.vue?vue&type=script&lang=js"

import "./GzList.vue?vue&type=style&index=0&id=2adc05d0&scoped=true&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adc05d0"]])

export default __exports__